export const wizardSteps = [
  'Student Details',
  'La Trobe Course',
  'Previous Learning',
  'Previous Subjects',
  'Existing Precedents',
  'Documentation',
  'Submission',
] as const

export const firstWizardStepIndex = 0
export const lastWizardStepIndex = wizardSteps.length - 1

export function isWizardStepIndex(index: number): boolean {
  return Number.isInteger(index) && index >= firstWizardStepIndex && index <= lastWizardStepIndex
}
